export default "__VITE_ASSET__DDAnwMVs__"